import React from 'react';

import {PubFilters} from 'store/pubs/pubSlice';

import {PubPageTableBody} from './PubPageTable/PubPageTableBody/PubPageTableBody';
import {PubPageTableHeader} from './PubPageTable/PubPageTableHeader';

interface IProps {
  filters: PubFilters;
}

export const PubPageTable = ({filters}: IProps) => {
  return (
    <div className="pub-pages__main-wrapper">
      <PubPageTableHeader filters={filters} />
      <PubPageTableBody />
    </div>
  );
};
